export default "__VITE_ASSET__9f1b6386__"